import { useEffect, useState } from "react";
import { loadGuideOrigin } from "./guide-origin";

/**
 * A link that actually leaves for the guide.
 *
 * Renders nothing until the address is known, and nothing at all where there is no separate
 * guide host — an absent link is better than one that returns the reader to the page they
 * asked to leave.
 */
export function GuideLink({ className, children }: { className?: string; children: React.ReactNode }) {
  const [origin, setOrigin] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void loadGuideOrigin().then((value) => { if (live) setOrigin(value); });
    return () => { live = false; };
  }, []);
  if (!origin) return null;
  return <a className={className} href={origin}>{children}</a>;
}
